import { EmptyListReason } from 'components/common/noTableContentInfo/NoTableContentInfo';
import { useMemo } from 'react';

export function useEmptyListReason(
  searchPhrase: string,
  total: number,
  activeFiltersLength: number,
  loading?: boolean,
  requestFailed?: boolean
): EmptyListReason | undefined {
  return useMemo(() => {
    // Don't show empty reason while loading
    if (loading) {
      return undefined;
    }

    const hasSearch = Boolean(searchPhrase);
    if (total === 0) {
      if (requestFailed) {
        return EmptyListReason.REQUEST_FAILED;
      }
      if (activeFiltersLength > 0) {
        return EmptyListReason.FILTER_MISMATCH;
      }
      if (hasSearch) {
        return EmptyListReason.SEARCHPHRASE_MISMATCH;
      }
      return EmptyListReason.NOTHING_IN_DB;
    }

    return undefined;
  }, [searchPhrase, total, activeFiltersLength, loading, requestFailed]);
}
